import { MPA_TRANSACTIONS_DELETE_REQUEST, MPA_TRANSACTIONS_DELETE_SUCCESS, MPA_TRANSACTIONS_DELETE_FAILURE } from './types/ManualPreadviceTransactionsDeleteActionsTypes';

export function deleteManualPreadviceTransactionsDeleteRequestActionCreator(context,
  selectedComments,
  selectedTransactionIds) {
  return {
    type: MPA_TRANSACTIONS_DELETE_REQUEST,
    payload: {
      appContext: context,
      params: {
        comments: selectedComments,
        transactionIdList: selectedTransactionIds,
      },
    },
  };
}

export function deleteManualPreadviceTransactionsDeleteSuccessActionCreator(data) {
  return {
    type: MPA_TRANSACTIONS_DELETE_SUCCESS,
    payload: data,
  };
}

export function deleteManualPreadviceTransactionsDeleteFailureActionCreator(error) {
  return {
    type: MPA_TRANSACTIONS_DELETE_FAILURE,
    payload: error,
    error: true,
  };
}
